module.exports = [{
      plugin: require('E:/github/pjb0811.github.io/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-79751268-3","exclude":["/","/tags","/tags/**","/tags/**/","/analysis"]},
    },{
      plugin: require('E:/github/pjb0811.github.io/node_modules/gatsby-plugin-lunr/gatsby-browser'),
      options: {"plugins":[],"languages":[{"name":"en","plugins":[null]}],"fields":[{"name":"title","store":true,"attributes":{"boost":20}},{"name":"tags","store":true},{"name":"content","store":true},{"name":"path","store":true}],"resolvers":{"MarkdownRemark":{}}},
    }]
